import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Clock, Tag, Flame } from 'lucide-react';
import { promoOffers } from '../data/mockData';

const PromoSection = () => {
  const featuredPromo = {
    title: "Frostbite OG - Limited Drop",
    subtitle: "Top-Shelf Exotic Gas",
    description: "Sealed fresh, icy nugs, heavy pressure. So cold it bite back.",
    image: "https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/ocbsreeg_IMG_0955.jpeg",
    pricing: "Starting at $30/5g",
    badge: "New Drop"
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Featured Drops & Deals
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't miss out on our latest premium strains and exclusive offers
          </p>
        </div>

        {/* Main Featured Promo */}
        <div className="mb-12">
          <div className="bg-gradient-to-r from-gray-900 to-green-900 rounded-2xl overflow-hidden shadow-2xl">
            <div className="grid lg:grid-cols-2 items-center">
              {/* Content */}
              <div className="p-8 lg:p-12 text-white">
                <Badge className="bg-yellow-500 text-gray-900 font-bold mb-4">
                  <Flame size={16} className="mr-2" />
                  {featuredPromo.badge}
                </Badge>
                
                <h3 className="text-3xl lg:text-4xl font-bold mb-3">
                  {featuredPromo.title}
                </h3>
                
                <p className="text-green-400 text-xl font-semibold mb-4">
                  {featuredPromo.subtitle}
                </p>
                
                <p className="text-gray-300 mb-6 text-lg leading-relaxed">
                  {featuredPromo.description}
                </p>
                
                <div className="mb-8">
                  <span className="text-2xl font-bold text-white">
                    {featuredPromo.pricing}
                  </span>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button 
                    size="lg" 
                    className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8"
                  >
                    Shop Frostbite OG
                  </Button>
                  <Button 
                    variant="outline" 
                    size="lg"
                    className="border-2 border-green-400 text-green-400 hover:bg-green-400 hover:text-gray-900"
                  >
                    View All Strains
                  </Button>
                </div>
              </div>
              
              {/* Image */}
              <div className="relative h-80 lg:h-full">
                <img 
                  src={featuredPromo.image}
                  alt={featuredPromo.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Promo Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {promoOffers.map((promo) => (
            <div key={promo.id} className="bg-gradient-to-br from-green-50 to-gray-100 rounded-xl p-6 border border-green-200">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    {promo.title}
                  </h4>
                  <p className="text-gray-700 mb-3">
                    {promo.description}
                  </p>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Clock size={16} />
                    <span>Valid until {promo.validUntil}</span>
                  </div>
                </div>
                <Badge className="bg-green-600 text-white">
                  <Tag size={14} className="mr-1" />
                  {promo.code}
                </Badge>
              </div>
              <Button className="w-full bg-green-600 hover:bg-green-700 text-white">
                Claim Offer
              </Button>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-gray-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Experience Big Dog Kush?
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Join thousands of satisfied customers who trust Big Dog Kush for their premium cannabis needs. 
            Quality guaranteed, satisfaction delivered.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-green-600 hover:bg-green-700 text-white px-8">
              Browse All Products
            </Button>
            <Button variant="outline" size="lg" className="px-8">
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoSection;